/* import __COLOCATED_TEMPLATE__ from './light-guide.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();